import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SYSTEM_STATES, systemStateHref } from "@/features/system-states/system-state";

export default function SystemStatesIndex() {
  return (
    <section aria-label="System states" className="w-full max-w-[880px]">
      <h1 className="text-lg font-bold text-ink">System states</h1>
      <p className="mt-2 text-sm text-muted">
        Route-group scaffolding for the system-state screens. The required states (loading, empty,
        permission denied, stale source, network error / 404, system maintenance, outcome unknown) are
        implemented in Phase 3 Batch P3-1 using the system-state primitives.
      </p>

      <ul className="mt-6 grid gap-3 sm:grid-cols-2">
        {SYSTEM_STATES.map((state) => (
          <li key={state.id}>
            <Link
              to={systemStateHref(state)}
              className="flex h-full flex-col rounded-lg border border-line bg-surface p-4 transition-colors hover:border-primary/40 hover:bg-primary-soft"
            >
              <span className="flex items-center gap-2">
                <span className="font-mono text-[11px] font-bold text-muted">{state.id}</span>
                <span className="text-sm font-bold text-ink">{state.title}</span>
                <ChevronRight aria-hidden className="ml-auto size-4 text-muted" />
              </span>
              <span className="mt-1.5 text-xs leading-relaxed text-muted">{state.purpose}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
